import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Injector,
  OnInit,
  Output,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AccessTokenInput, ConnectInput, GetAccessTokenInput, IAccessTokenInput, SharepointServiceProxy } from '@shared/service-proxies/service-proxies';
@Component({
  selector: 'app-connection-drawer',
  templateUrl: './connection-drawer.component.html',
  styleUrls: ['./connection-drawer.component.scss'],
  providers: [SharepointServiceProxy]
})
export class ConnectionDrawerComponent
  extends AppComponentBase
  implements OnInit, AfterViewChecked {

  @Output()
  loadConnectionList = new EventEmitter()
  connectionCreateCanvas;
  connecting: boolean = false;
  testConnecting: boolean = false;
  site_url: string = '';
  client_id: string = '';
  client_secret: string = '';
  testConnectionStatus: boolean = false;

  accessToken: string;
  domain: string;
  siteName: string = "";
  resourceId: string = "";
  sharepointTenantId: string = "";
  displaySiteName: string = "";

  constructor(
    injector: Injector,
    private _sharepointServerProxy: SharepointServiceProxy,

  ) {
    super(injector);
  }

  ngAfterViewChecked() {
    this.connectionCreateCanvas = new KTOffcanvas(
      'kt_connection-create__drawer',
      {
        overlay: true,
        baseClass: 'offcanvas',
        placement: 'right',
        closeBy: 'kt_connection-create__drawer_close',
        toggleBy: 'kt_open_create_drawer',
      }
    );

    this.connectionCreateCanvas.events.push(
      {
        name: 'afterShow',
        handler: () => {

        },
      },
      {
        name: 'beforeShow',
        handler: () => {
          document.querySelector('body').classList.add('overflowed');
        },
      },
      {
        name: 'beforeHide',
        handler: () => {
          document.querySelector('body').classList.remove('overflowed');
        },
      }
    );

    this.connectionCreateCanvas.events.push({
      name: 'afterHide',
      handler: () => {

      },
    });
  }

  ngOnInit(): void {
    abp.event.on('app.evt.openConnectionPanel', () => {
      this.openDrawer();
    });
  }

  async openDrawer() {
    this.connectionCreateCanvas.show();
  }

  closeDrawer() {
    this.connectionCreateCanvas.hide();
  }

  connect(): void {
    this.connecting = true;
    var connectInput: ConnectInput = {
      accessToken: this.accessToken,
      clientId: this.client_id,
      clientSecret: this.client_secret,
      siteName: this.siteName,
      domainName: this.domain,
      init: undefined,
      toJSON: undefined,
      resourceId: this.resourceId,
      sharePointSiteUrl: this.site_url,
      sharepointTenantId: this.sharepointTenantId,
      displaySiteName: this.displaySiteName,
    }
    this._sharepointServerProxy.connect(connectInput).subscribe((x) => {
      this.connecting = false;
      this.closeDrawer();
      if (x) {
        this.loadConnectionList.emit()
        this.message.success(this.l('testConnectionSuccessMsg'), '')
        this.site_url = undefined;
        this.client_id=undefined;
        this.client_secret =undefined;
        this.testConnectionStatus = false;
      }
      else {
        this.message.error(this.l('testConnectionErrorMsg'), '')
      }

    },()=>{
      this.connecting = false;
    })
  }



  testConnection(): void {
    var path = (new URL(this.site_url));
    this.domain = path.hostname.split(".")[0]
    var directories = path.toString().split('/')
    this.siteName = directories[(directories.length - 1)];
    this.testConnecting = true;
    this._sharepointServerProxy.getTenantAndResourceId(this.siteName, this.domain).subscribe(x => {
      this.resourceId = x.resourceId
      this.sharepointTenantId = x.sharepointTenantId;
      var inputToGetToken: GetAccessTokenInput = { clientId: this.client_id, sharepointTenantId: this.sharepointTenantId, clientSecret: this.client_secret, resourceId: this.resourceId, accessToken: "", domainName: this.domain, siteName: this.siteName, init: null, toJSON: null }
      this._sharepointServerProxy
        .sharepointAccessToken(inputToGetToken)
        .subscribe(y => {
          this.accessToken = y.accessToken
          let input: AccessTokenInput = { accessToken: this.accessToken, domainName: this.domain, siteName: this.siteName, init: null, toJSON: null }
          this._sharepointServerProxy.testConnection(input).subscribe(z => {
            this.testConnectionStatus = z.isConnectionSuccessful
            this.displaySiteName = z.siteName
            this.testConnecting = false;

            if (this.testConnectionStatus) {
              this.message.success(this.l('testConnectionSuccessMsg'), '')
            }
            else {
              this.message.error(this.l('testConnectionErrorMsg'), '')
            }
          })
        });
    }, error => {
        this.message.error(this.l('testConnectionErrorMsg'), '')
        this.testConnecting = false;
    });
  }

}
